import { FiSearch } from "react-icons/fi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { GoDotFill } from "react-icons/go";
import { HiPlus } from "react-icons/hi";
import { useContext } from "react";
import { TabContext } from "../../../App";
import { useSelector } from "react-redux";
import { ACTIVETAB } from "../../Actions/actions";
import { useDispatch } from "react-redux";
import { IoIosNotifications, IoIosNotificationsOutline } from "react-icons/io";
import { IoNotificationsOutline } from "react-icons/io5";

const formatRouteTitle = (route) =>
  decodeURIComponent(route)
    .replaceAll("-", " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

const PrimaryHeader = ({
  PrivilagesCondition,
  onButtonClick,
  buttonTextfirst,
  onButtonClickfirst,
  onfirstButtonClick,
  buttonIconfirst,
  PrivilagesConditionAsset,
  buttonText = "Add",
  buttonIcon = <HiPlus className="mr-2" />,
  userImage = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQH5sFjZPx1Yzi1b9_FpQzrxqgsjv2DPAp81Q&s",
}) => {
  const location = useLocation();
  const paths = location.pathname.split("/").filter(Boolean);
  const filteredPaths = paths.filter((path) => path.toLowerCase() !== "details");
  const { role, loginData, singleClient, subLoader, singleAdmin, notificationCount,Privilages } = useSelector((state) => state.userReducer);

  const Breadcrumb = () => {
    return (
      <nav className="text-gray-500 text-sm flex items-center gap-2 mt-2">
        <a onClick={() => {
          dispatch({
            type: ACTIVETAB,
            payload: 'Dashboard',
          });
        }} href="/dashboard" className="hover:underline text-gray-800">
          Dashboard
        </a>

        {filteredPaths.map((path, index) => {
          const fullPath = `/${filteredPaths.slice(0, index + 1).join("/")}`;
          const isLast = index === filteredPaths.length - 1;

          return (
            <div key={fullPath} className="flex items-center gap-2">
              <GoDotFill color="grey" size={10} />
              {!isLast ? (
                <Link to={fullPath} className="hover:underline text-gray-800">
                  {formatRouteTitle(path)}
                </Link>
              ) : (
                <span className="text-gray-800">{formatRouteTitle(path)}</span>
              )}
            </div>
          );
        })}
      </nav>
    );
  };
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const isRestricted = Privilages?.some(
    (priv) => priv.feature === 'Notifications' && priv.accessLevel === "Restricted"
  );
  return (
    <div>
      <div className="md:block sm:hidden">
        <div className=" flex justify-between items-center mb-10">
          <div className="flex items-center">
            {/* <FiSearch className="text-gray-400 w-5 h-5" /> */}
          </div>
          <div className="flex gap-2 items-center flex-row">
            {isRestricted ? null :
              <div className="relative cursor-pointer">
                <IoNotificationsOutline
                  onClick={() => {
                    dispatch({
                      type: ACTIVETAB,
                      payload: 'Notifications',
                    });
                    navigate("/notifications");
                  }}
                  size={25}
                  className="text-gray-700"
                />
                {notificationCount?.count > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] w-4 h-4 flex items-center justify-center rounded-full">
                    {notificationCount.count}
                  </span>
                )}
              </div>}

            <p className="font-medium text-sm text-gray-800">
              {role === 'Admin' ? 'Admin' : singleClient?.businessName}
            </p>

            {(singleAdmin?.logo || singleClient?.logo) ? (
              <img
                onClick={() => {
                  dispatch({
                    type: ACTIVETAB,
                    payload: 'Settings',
                  });
                  navigate("/settings");
                }}
                src={
                  role === 'Admin'
                    ? (singleAdmin?.logo || userImage)
                    : (singleClient?.logo || userImage)
                }
                className="w-10 h-10 rounded-full cursor-pointer"
                alt="User"
              />
            ) : (
              <p className="font-bold text-gray-400 text-lg w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                {role === 'Admin'
                  ? singleAdmin?.firstname?.slice(0, 1)
                  : singleClient?.businessName?.slice(0, 1)}
              </p>
            )}
          </div>


        </div>
      </div>
      <div className="flex flex-row justify-between items-center mb-14">
        <div className="mb-4 lg:mb-0">
          <h1 className="text-2xl font-semibold text-gray-800">
            {formatRouteTitle(location.pathname.split("/")[1])}
          </h1>
          <Breadcrumb />
        </div>
        {PrivilagesCondition ?
          <div className="flex md:flex-row sm:flex-col">
            {!!onButtonClickfirst && (
              <button
                className="bg-white md:mr-4 md:mb-0 sm:mb-2 text-[#361D32] px-4 py-2 rounded-lg flex items-center shadow-md hover:bg-gray-200"
                onClick={onfirstButtonClick}
              >
                {buttonIconfirst}
                {buttonTextfirst}
              </button>
            )}
            {!!onButtonClick && (
              <button
                className="bg-[#361D32] text-white px-4 py-2 rounded-lg flex items-center shadow-md hover:bg-[#180e17]"
                onClick={onButtonClick}
              >
                {buttonIcon}
                {buttonText}
              </button>
            )}
          </div>
          : null}
        {PrivilagesConditionAsset ?
          <div className="flex md:flex-row sm:flex-col">

            {!!onButtonClickfirst && (
              <button
                className="bg-white md:mr-4 md:mb-0 sm:mb-2 text-[#361D32] px-4 py-2 rounded-lg flex items-center shadow-md hover:bg-gray-200"
                onClick={onfirstButtonClick}
              >
                {buttonIconfirst}
                {buttonTextfirst}
              </button>
            )}
          </div>
          : null}

      </div>

    </div>
  );
};

export default PrimaryHeader;
